import axios from "axios";

export const BASE_URL = "https://immersive-game-india.confirmu.com";

export let headers = {
  "Tenant-Access-Token": "YjM0N2ZlMzZmMDhhODlhZmFlNTU0ZmIxOTc1NzgyYmM=",
  "Tenant-Access-Key": "jYnrVwF8SK8wZg",
};


export const api = axios.create({
  baseURL: BASE_URL,
  headers,
});